import { ChangeEvent, FC, useCallback } from 'react';
import S from './SwitchButton.module.scss';
import { Text } from 'src/redesign/components/Text';

type SwitchButtonProps = {
  items: [string, string];
  onChange: (item: string) => void;
  className?: string;
};

export const SwitchButton: FC<SwitchButtonProps> = (props) => {
  const handleOnClick = useCallback(
    (event: ChangeEvent<HTMLInputElement>) => {
      if (event.target.checked) {
        props.onChange(props.items[1]);
        return;
      }
      props.onChange(props.items[0]);
    },
    [props]
  );

  return (
    <div>
      <input onChange={handleOnClick} type="checkbox" id="toggle" className={S.toggleCheckbox} />
      <label htmlFor="toggle" className={S.toggleContainer}>
        {props.items.map((item) => (
          <Text key={item} variation="body">
            {item}
          </Text>
        ))}
      </label>
    </div>
  );
};
